module.exports = __webpack_public_path__ + "static/img/character.e8543c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/character.png
// module id = Tdwu
// module chunks = 0